export enum ClientSideActions {
  APPEND = "append",
  CLEAR = "clear",
  EMIT = "emit",
  NOTIFY = "notify",
  SET = "set",
  RETRY = "retry",
  INTERRUPT = "interrupt",
}
